module.exports = __webpack_public_path__ + "static/media/vijay.cb97594c.jpg";